import { dateRangeOperators } from "../../../Pages/DataManagement/DataExplorer/DataExplorerUI/ExplorerInputs/FieldOperatorList";

function setDefaultOperatorModeFilter(filter) {
  return {
    name: filter.type,
    isMuted: filter.isMuted,
    ...(filter.filters && { filters: filter.filters }),
    ...(filter.ignoreCaseSensitivity && { ignoreCaseSensitivity: "1" }),
    ...(filter.conditional && { conditional: true }),
  };
}

function setSubQueryValuesOperatorMode(filter) {
  const { operator, value, type, aggregation } = filter.subQueryValues;

  return {
    operator: operator || "==",
    values: [value],
    aggregation: { type: aggregation },
    name: type,
  };
}

function getValuesOperatorMode(filters, name) {
  return [
    ...new Set(
      (filters ?? []).filter((fil) => fil.type === name).map((fil) => fil.value)
    ),
  ].filter((value) => value !== undefined);
}

function getOperator(filter, options) {
  return filter.operator || (options.noOperatorFallback ? undefined : "==");
}

function isGroupFilter(filter) {
  return Array.isArray(filter.filters);
}

function hasSubQuery(filter) {
  return Boolean(filter.subQueryValues);
}

// Use this to go FROM API format TO useFilters format
export default function (filters, options = {}) {
  return (filters ?? []).reduce((acc, filter) => {
    if (isGroupFilter(filter)) {
      acc.push(filter);
      return acc;
    }

    const existingIndex = acc.findIndex((f) => f.name === filter.type);
    const values = getValuesOperatorMode(filters, filter.type);

    if (existingIndex > -1) {
      acc[existingIndex].values = values;
      return acc;
    }

    const baseFilter = setDefaultOperatorModeFilter(filter);

    if (hasSubQuery(filter)) {
      acc.push({
        ...baseFilter,
        subQueryValues: setSubQueryValuesOperatorMode(filter),
      });
      return acc;
    }

    acc.push({
      ...baseFilter,
      operator: getOperator(filter, options),
      values,
    });

    return acc;
  }, []);
}

function setDefaultConfigModeFilter(filter, index, muted) {
  function setInnerMuted(filters) {
    return filters.map((filter, innerIndex) => {
      const isMuted = muted?.includes(index + "::" + innerIndex);

      return {
        ...filter,
        isMuted,
      };
    });
  }

  const isMuted = muted?.includes(index);

  return {
    ...(filter.name && { type: filter.name }),
    ...(filter.filters && {
      filters: setInnerMuted(filter.filters),
    }),
    isMuted,
    ...(filter.ignoreCaseSensitivity && {
      ignoreCaseSensitivity: "1",
    }),
    ...(filter.conditional && { conditional: true }),
  };
}

function setSubQueryValuesConfigMode(filter, muted) {
  return {
    ...convertFiltersToConfigFormat([filter.subQueryValues], muted)[0],
    aggregation:
      filter.subQueryValues.aggregation?.type ?? filter.aggregation?.type,
  };
}

// Use this to go TO API format and FROM useFilters format
export function convertFiltersToConfigFormat(filters, muted) {
  return (filters ?? []).reduce((acc, curr, index) => {
    const configFilter = setDefaultConfigModeFilter(curr, index, muted);

    if (curr.subQueryValues) {
      return [
        ...acc,
        {
          ...configFilter,
          subQueryValues: setSubQueryValuesConfigMode(curr, muted),
        },
      ];
    }

    if ((curr.name && !curr.values?.length) || curr.filters?.length) {
      return [...acc, configFilter];
    }

    return [
      ...acc,
      ...(curr.values ?? []).map((v) => {
        const notRange = !dateRangeOperators.includes(curr.operator);

        if (curr.operator && curr.operator !== "==" && notRange) {
          configFilter.operator = curr.operator;
        }

        return { ...configFilter, value: v };
      }),
    ];
  }, []);
}

export function convertOverridesToConfigFormat(overrides = []) {
  return overrides.map(({ name, mapping, aggregation }) => ({
    name,
    ...(mapping && { mapping }),
    ...(aggregation && { aggregation: aggregation.type }),
  }));
}
